import { render, staticRenderFns } from "./article-index.vue?vue&type=template&id=9a3529ac&scoped=true&"
import script from "./article-index.vue?vue&type=script&lang=js&"
export * from "./article-index.vue?vue&type=script&lang=js&"
import style0 from "./article-index.vue?vue&type=style&index=0&id=9a3529ac&prod&scoped=true&lang=css&"
import style1 from "./article-index.vue?vue&type=style&index=1&id=9a3529ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3529ac",
  null
  
)

export default component.exports